import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  useDefaultPasscodeStyles,
  switchControl,
  selectField,
  getSelectValues,
  getSelectedValueTranslated,
  getKeyFromSelectedValue,
} from "../../../constants/passCodeUtils";

import {
  PASSWORD_VALID_WITH_COUNT,
  FIRST_PARTY_ON_HOLD,
  PARTICIPANT_NAME_RECORD,
  PLAY_FIRST_CALLER_MESSAGE,
  CONFERENCE_QUICK_START,
  DOUBLE_PASSCODE_ENTRY,
  CONFERENCE_LEVEL_PASSCODE,
} from "../../../utils/responseValue";
import { MIN_DESKTOP_WIDTH } from "../../../constants/ui";

const PMEntry = ({ confRestRep, setConfRestRep, selectValues, translate }) => {
  const pc = useDefaultPasscodeStyles();
  const isDesktop = useMediaQuery(`(min-width:${MIN_DESKTOP_WIDTH})`);

  const handleSwitchChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.checked });
  };
  const handleSelectChange = name => event => {
    setConfRestRep({
      ...confRestRep,
      [name]: getKeyFromSelectedValue(selectValues[name], event.target.value),
    });
  };

  const customStyle = theme => ({
    formControl: {
      width: "250px",
    },
  });

  return (
    <Box component="form" sx={pc.container} noValidate autoComplete="off">
      {switchControl(
        pc,
        confRestRep[PLAY_FIRST_CALLER_MESSAGE],
        PLAY_FIRST_CALLER_MESSAGE,
        translate[PLAY_FIRST_CALLER_MESSAGE],
        handleSwitchChange(PLAY_FIRST_CALLER_MESSAGE)
      )}
      <Box sx={pc.lineBreak} />
      {switchControl(
        pc,
        confRestRep[PASSWORD_VALID_WITH_COUNT],
        PASSWORD_VALID_WITH_COUNT,
        translate[PASSWORD_VALID_WITH_COUNT],
        handleSwitchChange(PASSWORD_VALID_WITH_COUNT)
      )}
      <Box sx={pc.lineBreak} />
      {switchControl(
        pc,
        confRestRep[PARTICIPANT_NAME_RECORD],
        PARTICIPANT_NAME_RECORD,
        translate[PARTICIPANT_NAME_RECORD],
        handleSwitchChange(PARTICIPANT_NAME_RECORD)
      )}
      <Box sx={pc.lineBreak} />
      {switchControl(
        pc,
        confRestRep[CONFERENCE_QUICK_START],
        CONFERENCE_QUICK_START,
        translate[CONFERENCE_QUICK_START],
        handleSwitchChange(CONFERENCE_QUICK_START)
      )}
      <Box sx={pc.lineBreak} />
      {switchControl(
        pc,
        confRestRep[FIRST_PARTY_ON_HOLD],
        FIRST_PARTY_ON_HOLD,
        translate[FIRST_PARTY_ON_HOLD],
        handleSwitchChange(FIRST_PARTY_ON_HOLD)
      )}
      <Box sx={pc.lineBreak} />
      {selectField(
        customStyle,
        translate[DOUBLE_PASSCODE_ENTRY],
        getSelectValues(selectValues, DOUBLE_PASSCODE_ENTRY),
        getSelectedValueTranslated(confRestRep[DOUBLE_PASSCODE_ENTRY], selectValues, DOUBLE_PASSCODE_ENTRY),
        handleSelectChange(DOUBLE_PASSCODE_ENTRY),
      isDesktop
      )}
      <Box sx={pc.lineBreak} />
      {selectField(
        customStyle,
        translate[CONFERENCE_LEVEL_PASSCODE],
        getSelectValues(selectValues, CONFERENCE_LEVEL_PASSCODE),
        getSelectedValueTranslated(confRestRep[CONFERENCE_LEVEL_PASSCODE], selectValues, CONFERENCE_LEVEL_PASSCODE),
        handleSelectChange(CONFERENCE_LEVEL_PASSCODE),
      isDesktop
      )}
    </Box>
  );
};

PMEntry.propTypes = {
  confRestRep: PropTypes.object.isRequired,
  selectValues: PropTypes.object.isRequired,
  setConfRestRep: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
};

export default PMEntry;
